import React, { useState, useRef, useEffect } from 'react';
import { Play, Pause, SkipBack, SkipForward, Volume2 } from 'lucide-react';

const MusicPlayerCard = () => {
    const [cards] = useState([
        // {
        //     id: 1,
        //     title: 'THARUMANKAL',
        //     artist: 'Artist Name',
        //     gradient: 'from-purple-900 via-purple-800 to-purple-900',
        //     audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379860/01_fcdjj0.mp3"
        // },
        // {
        //     id: 2,
        //     title: 'NARAYANAM POGUM NAL',
        //     artist: 'Artist Name',
        //     gradient: 'from-pink-600 via-orange-500 to-orange-400',
        //     audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379853/2_pzupu7.mp3"
        // },
        {
            id: 1,
            title: 'Mudipugazhndha ammanai audio 1',
            artist: 'Artist Name',
            gradient: 'from-pink-600 via-orange-500 to-orange-400',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379851/ammanai1_kaly9f.mp3"
        },
        {
            id: 2,
            title: 'Mudipugazhndha ammanai audio 2',
            artist: 'Artist Name',
            gradient: 'from-pink-600 via-orange-500 to-orange-400',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379855/ammanai2_z88c7f.mp3"
        },
        {
            id: 3,
            title: 'Mudipugazhndha ammanai audio 3',
            artist: 'Artist Name',
            gradient: 'from-pink-600 via-orange-500 to-orange-400',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379857/ammanai3_rtyaej.mp3"
        },
        {
            id: 4,
            title: 'Mudipugazhndha ammanai audio 4',
            artist: 'Artist Name',
            gradient: 'from-pink-600 via-orange-500 to-orange-400',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379862/ammanai4_in4fmj.mp3"
        },
        {
            id: 5,
            title: 'Mudipugazhndha ammanai audio 5',
            artist: 'Artist Name',
            gradient: 'from-pink-600 via-orange-500 to-orange-400',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379858/ammanai5_b1iq2v.mp3"
        },
        {
            id: 6,
            title: 'Mudipugazhndha ammanai audio 6',
            artist: 'Artist Name',
            gradient: 'from-pink-600 via-orange-500 to-orange-400',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379864/ammanai6_ysaygx.mp3"
        },
        {
            id: 7,
            title: 'Introduction',
            artist: 'Artist Name',
            gradient: 'from-purple-400 via-purple-500 to-purple-700',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1764262344/Track01_rlf43m.mp3"

        },
        {
            id: 8,
            title: 'மதகநெல்லூர் சுவாமிகளின் புகழை பாடுங்கடி',
            artist: 'Artist Name',
            gradient: 'from-purple-400 via-purple-500 to-purple-700',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1764262993/Track02_nntbg7.mp3"

        },
        {
            id: 9,
            title: 'ஏடு தந்த அய்யா',
            artist: 'Artist Name',
            gradient: 'from-purple-400 via-purple-500 to-purple-700',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1764262718/Track03_arzb2o.mp3"

        },
        {
            id: 10,
            title: 'இப்பூமி ஆனதெல்லாம்',
            artist: 'Artist Name',
            gradient: 'from-purple-400 via-purple-500 to-purple-700',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1764263491/Track04_ferjim.mp3"

        },
        {
            id: 11,
            title: 'மதகநெல்லூரில் பிறந்த எங்கள் அய்யா',
            artist: 'Artist Name',
            gradient: 'from-purple-400 via-purple-500 to-purple-700',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1764263425/Track05_kgkpap.mp3"

        },
        {
            id: 12,
            title: 'வருகின்றார் அருளை',
            artist: 'Artist Name',
            gradient: 'from-purple-400 via-purple-500 to-purple-700',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1764263408/Track06_ya2szs.mp3"

        },
        {
            id: 13,
            title: 'அய்யா அய்யா தெய்வமய்யா',
            artist: 'Artist Name',
            gradient: 'from-purple-400 via-purple-500 to-purple-700',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1764263406/Track07_wdvkcy.mp3"

        },
        {
            id: 14,
            title: 'ஏடு உனக்கு துணை',
            artist: 'Artist Name',
            gradient: 'from-purple-400 via-purple-500 to-purple-700',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1764262905/Track08_xwexfv.mp3"

        },
        {
            id: 15,
            title: 'அரசமர நிழலில்',
            artist: 'Artist Name',
            gradient: 'from-purple-400 via-purple-500 to-purple-700',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1764263276/Track09_yozip7.mp3"

        },
        {
            id: 16,
            title: 'நெல்லு விளையும் ஊரு',
            artist: 'Artist Name',
            gradient: 'from-purple-400 via-purple-500 to-purple-700',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1764263474/Track10_btuirf.mp3"

        },
        // {
        //     id: 17,
        //     title: 'INTRODUCTION',
        //     artist: 'Artist Name',
        //     gradient: 'from-fuchsia-500 via-rose-500 to-pink-600',
        //     audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763380835/intro_qqsrrh.mp3"
        // },
        {
            id: 18,
            title: 'அய்யாவின் நாமம் அதிசய நாமம்',
            artist: 'Artist Name',
            gradient: 'from-fuchsia-500 via-rose-500 to-pink-600',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379843/song1_hr2wlw.mp3"
        },
        {
            id: 19,
            title: 'அகில உலகிற்கும் படியளக்கும்',
            artist: 'Artist Name',
            gradient: 'from-fuchsia-500 via-rose-500 to-pink-600',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379846/song2_x9fept.mp3"
        },
        {
            id: 20,
            title: 'ஆழியில் துயில் கொள்ளும் ஆதவனே',
            artist: 'Artist Name',
            gradient: 'from-fuchsia-500 via-rose-500 to-pink-600',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379843/song3_ygbaue.mp3"
        },
        {
            id: 21,
            title: 'அய்யாவின் புகழ் பாடி',
            artist: 'Artist Name',
            gradient: 'from-fuchsia-500 via-rose-500 to-pink-600',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379846/song4_sqigie.mp3"
        }, {
            id: 22,
            title: 'சிவ சிவம் நாராயணம்',
            artist: 'Artist Name',
            gradient: 'from-fuchsia-500 via-rose-500 to-pink-600',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379847/song5_djkclt.mp3"
        },
        {
            id: 23,
            title: 'கைலாச வாழ்புரத்தின்',
            artist: 'Artist Name',
            gradient: 'from-fuchsia-500 via-rose-500 to-pink-600',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379848/song6_scm57j.mp3"
        },
        {
            id: 24,
            title: 'அவதார புகழ் பாடி',
            artist: 'Artist Name',
            gradient: 'from-fuchsia-500 via-rose-500 to-pink-600',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379846/song7_oeeldn.mp3"
        }, {
            id: 25,
            title: 'வங்க கடற்கரை வனமதிலே',
            artist: 'Artist Name',
            gradient: 'from-fuchsia-500 via-rose-500 to-pink-600',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379847/song8_kmzdzk.mp3"
        },
        {
            id: 26,
            title: 'அதிசயமாம் அதிசயமாம் ',
            artist: 'Artist Name',
            gradient: 'from-fuchsia-500 via-rose-500 to-pink-600',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379848/song9_hvjmnl.mp3"
        },
        {
            id: 27,
            title: 'மதகை வாழும் அய்யா',
            artist: 'Artist Name',
            gradient: 'from-fuchsia-500 via-rose-500 to-pink-600',
            audio: "https://res.cloudinary.com/dwu5s4j0i/video/upload/v1763379848/song10_brwrpv.mp3"
        },

    ]);

    const [playingId, setPlayingId] = useState(null);
    const [progress, setProgress] = useState({});
    const [duration, setDuration] = useState({});
    const audioRefs = useRef({});

    useEffect(() => {
        cards.forEach(card => {
            if (!audioRefs.current[card.id]) {
                audioRefs.current[card.id] = new Audio(card.audio);

                audioRefs.current[card.id].addEventListener("timeupdate", () => {
                    setProgress(prev => ({
                        ...prev,
                        [card.id]: audioRefs.current[card.id].currentTime,
                    }));
                });

                audioRefs.current[card.id].addEventListener("loadedmetadata", () => {
                    setDuration(prev => ({
                        ...prev,
                        [card.id]: audioRefs.current[card.id].duration,
                    }));
                });

                audioRefs.current[card.id].addEventListener("ended", () => {
                    setPlayingId(null);
                });
            }
        });

        return () => {
            Object.values(audioRefs.current).forEach(audio => {
                audio.pause();
                audio.src = "";
            });
        };
    }, [cards]);

    const togglePlay = (id) => {
        if (playingId === id) {
            audioRefs.current[id].pause();
            setPlayingId(null);
        } else {
            if (playingId !== null) audioRefs.current[playingId].pause();
            audioRefs.current[id].play();
            setPlayingId(id);
        }
    };

    const formatTime = (seconds) => {
        if (!seconds || isNaN(seconds)) return "0:00";
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs.toString().padStart(2, "0")}`;
    };

    return (
        <div className="min-h-screen pt-24 px-4">
            {/* RESPONSIVE GRID FIX */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-7xl mx-auto">
                {cards.map(card => (
                    <div
                        key={card.id}
                        className={`bg-gradient-to-br ${card.gradient} rounded-3xl p-6 shadow-xl w-full`}
                    >
                        <h3 className="text-white text-lg font-semibold mb-4">{card.title}</h3>

                        <div className="bg-white/10 backdrop-blur-md rounded-2xl h-40 mb-5 flex items-center justify-center">
                            <Volume2 size={48} className="text-white/40" />
                        </div>

                        <input
                            type="range"
                            min="0"
                            max={duration[card.id] || 100}
                            value={progress[card.id] || 0}
                            onChange={(e) => {
                                audioRefs.current[card.id].currentTime = parseFloat(e.target.value);
                                setProgress(prev => ({ ...prev, [card.id]: parseFloat(e.target.value) }));
                            }}
                            className="w-full accent-white"
                        />

                        <div className="flex justify-between text-white text-xs opacity-80 mt-1 mb-4">
                            <span>{formatTime(progress[card.id])}</span>
                            <span>{formatTime(duration[card.id])}</span>
                        </div>

                        <div className="flex items-center justify-between mt-2">
                            <button className="text-white">
                                <SkipBack size={24} />
                            </button>

                            <button
                                onClick={() => togglePlay(card.id)}
                                className="bg-white text-gray-900 rounded-full p-3 shadow-md active:scale-95"
                            >
                                {playingId === card.id ? <Pause size={24} /> : <Play size={24} className="ml-1" />}
                            </button>

                            <button className="text-white">
                                <SkipForward size={24} />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MusicPlayerCard;
